import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXAds = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M11.293.02h27.414C44.945.02 50 5.094 50 11.352v27.296c0 6.258-5.055 11.336-11.293 11.336H11.293C5.055 49.98 0 44.906 0 38.648V11.352C0 5.094 5.055.02 11.293.02Zm0 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M31.617 14.563h3.528l-7.711 8.84 9.07 12.035h-7.102l-5.558-7.297-6.364 7.297h-3.527l8.242-9.458-8.699-11.418h7.281l5.024 6.668ZM30.38 33.32h1.953L19.715 16.57h-2.098Zm0 0"
	})]
});
export default SvgXAds;
